const staticPages = {
    comingSoon: 'The page is still in development',
};

export default staticPages;
